<template lang="html">
  <Container dark name="arrangement">
    <div class="axiox-content">
      <div class="row" :class="{'shift' : showText }" @mouseleave="showText = false">
        <div class="column">
          <Axiox :clicking="() => {showText = true}" :callback="hoverElement"/>
        </div>
        <div class="column">
          <h1 v-html="selected === null ? components.default.header : selected.header">
            <!-- {{selected === null ? components.default.header : selected.header}} -->
          </h1>
          <transition name="fade">
            <p v-if="showText">{{selected === null ? components.default.description : selected.description}}</p>
          </transition>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from '../components/Container'
import Axiox from '../components/Axiox'

export default {
  components: { Container, Axiox },
  data: () => ({
    components: {
      default: {
        header: 'Гибридная док&#8209;станция',
        description: 'Платформа, к которой в режиме plug&play может быть подключено: восемь силовых ключей-компьютеров, центральный компьютер управления с дисплеем, клеммная колодка. На док-станции расположены: узел для подключения внешних активных слаботочных интерфейсов (LAN, USB, Wi-Fi, Bluetooth), узел для подключения внешних информационных интерфейсов, единый сильноточный вводный узел (одно или трех фазного исполнения)  для электрического подключения устройства в целом, единый сильноточный транзитный узел масштабирования дополнительной док-станции к одному центральному компьютеру управления, центральный узел для подключения внешних потребителей. Платформа позволяет подключать при помощи интерфейсов требуемое количество силовых ключей.'
      },
      modules: {
        header: 'Силовой ключ&#8209;компьютер',
        description: `Гибридная вычислительная машина - компьютер базового преобразования силовых токов - цифроаналоговое устройство коммутации и обработки электрических сигналов. С помощью силовых ключей происходит коммутация, прием-передача и обработка как электрических, так и информационных сигналов электроустановки.
Каждый силовой ключ включает в себя внутреннюю релейную защиту. Внутренняя релейная защита предназначена для быстрого, автоматического (при повреждениях) выявления и отделения от электроэнергетической системы повреждённых в аварийных ситуациях элементов с целью обеспечения нормальной работы всей системы. Действия средств внутренней релейной защиты организованы по принципу непрерывной оценки технического состояния отдельных контролируемых элементов электроэнергетической системы. Внутренняя релейная защита осуществляет непрерывный контроль состояния всех элементов электроэнергетической системы и реагирует на возникновение повреждений и ненормальных режимов. При возникновении повреждений, внутренняя релейная защита выявляет повреждённый участок и отключает его от электроэнергетической системы. При
этом, каждый силовой ключ оборудован блоком внешней релейной защиты, которая работает по тому же принципу и дублирует внутреннюю релейную защиту.`
      },
      computer: {
        header: 'Центральный компьютер',
        description: `Центральный компьютер управления с дисплеем путем информационного обмена постоянно осуществляет диагностику и управление всеми подключенными в общую систему гибридными вычислительными машинами - силовыми ключами. При аварийной ситуации в работе силового ключа, центральный компьютер при помощи внешней релейной защиты обесточивает внутреннюю релейную защиту в силовом ключе и принимает управление электрической цепью и конечными потребителями на себя. При этом вышедший из строя силовой ключ можно заменить, не отключая подачу тока на электросетевой компьютер.
Программа центрального компьютера управления содержит специальные алгоритмы, которые необходимы для определения всех подключенных по общей шине устройств. Они же позволяют загрузить специальные функциональные программы для гибридных вычислительных машин, при этом объединяя их в общую сеть обмена данными, тем самым обеспечивая всю систему общей операционной системой с обратной связью. За счет реализации такой технологии достигается синхронизация устройств и приобретается сущность работы в качестве цифрового устройства локальной электроустановки и электрической сети в целом.`
      },
      block: {
        header: 'Клемная панель',
        description: 'Обеспечивает подключение внешних потребителей.'
      }
    },
    selected: null,
    showText: false
  }),
  methods: {
    hoverElement (id, clicked) {
      if (id !== null) {
        this.selected = this.components[id]
      } else {
        this.selected = this.components.default
      }
    }
  }
}
</script>

<style lang="css" scoped>
  @media screen and (max-width: 800px) {
    .row {
      width: 90%;
      padding-top: 100px;
      padding-bottom: 100px;
      margin: 0px 5%;
      /* height: 100vh; */
    }
    .column {
      position: relative;
      transition: .3s;
      width: 100%;
    }
    .shift{
      /* transition: .3s; */
    }
    .shift .column:first-child {
      /* width: 40%; */
    }
    .shift .column:last-child {
      /* width: 60%; */
    }
    .column h1 {
      position: relative;
      margin-top: 30px;
      margin-bottom: 60px;
      font-style: normal;
      font-weight: 200;
      /* font-size: 2.5vw; */
      font-size: 24px;
      line-height: 100%;
      max-width: 600px;
    }
    .column h1:before {
      content : "";
      position: absolute;
      left    : 0;
      bottom  : -20px;
      height  : 1px;
      width   : 80%;
      max-width: 300px;
      border-bottom: 1px solid #363636;
    }
    .column p {
      line-height: 150%;
      overflow-y: auto;
      /* height: 700px; */
      font-size: 16px;
    }
  }
  @media screen and (min-width: 800px) {
    .axiox-content {
      min-height: 100vh;
      max-height: 900px;
    }
    .row {
      width: 80%;
      margin: 0 10%;
      padding-top: 5%;
      /* padding-bottom: 150px; */

      position: absolute;
      top:50%;
      transform: translateY(-50%);
    }
    .column {
      position: relative;
      display: inline-block;
      vertical-align: top;
      padding: 10px;
      transition: .3s;
    }
    .column:first-child {
      width: 60%;
    }
    .column:last-child {
      width: 40%;
    }
    .shift{
      top: 0;
      transform: translateY(0%);
      transition: .3s;
    }
    .shift .column:first-child {
      width: 40%;
    }
    .shift .column:last-child {
      width: 60%;
    }
    .column h1 {
      position: relative;
      margin-top: 30px;
      margin-bottom: 60px;
      font-style: normal;
      font-weight: 200;
      font-size: 2.5vw;
      line-height: 100%;
      max-width: 600px;
    }
    .column h1:before {
      content : "";
      position: absolute;
      left    : 0;
      bottom  : -20px;
      height  : 1px;
      width   : 80%;
      max-width: 300px;
      border-bottom: 1px solid #363636;
    }
    .column p {
      line-height: 150%;
      overflow-y: auto;
      height: 700px;
      font-size: calc(0.5vw + 10px);
    }
  }
  /* div {
    box-sizing: border-box;
  }
  .axiox-content {
    position: relative;
  }
  .row {
    width: 80%;
    margin: 0 10%;
    padding-top: 100px;
    padding-bottom: 100px;
    min-height: 90vh;
    max-height: 900px;
  }
  .column {
    position: relative;
    display: inline-block;
    vertical-align: top;
    padding: 10px;
    transition: .3s;
  }
  .column:first-child {
    width: 70%;
  }
  .column:last-child {
    width: 30%;
  }
  .shift{
    transition: .3s;
  }
  .shift .column:first-child {
    width: 40%;
  }
  .shift .column:last-child {
    width: 60%;
  }
  .column h1 {
    position: relative;
    margin-top: 30px;
    margin-bottom: 60px;
    font-style: normal;
    font-weight: 200;
    font-size: 2.5vw;
    line-height: 100%;
    max-width: 600px;
  }
  .column h1:before {
    content : "";
    position: absolute;
    left    : 0;
    bottom  : -20px;
    height  : 1px;
    width   : 80%;
    max-width: 300px;
    border-bottom: 1px solid #363636;
  }
  .column p {
    line-height: 150%;
    overflow-y: auto;
    height: 700px;
    font-size: calc(0.5vw + 10px);
  }
   */
   .fade-enter-active {
     transition: 1s;
   }
   .fade-leave-active {
     transition: .3s;
   }
   .fade-enter, .fade-leave-to {
     opacity: 0;
   }
</style>
